import { createFileRoute } from '@tanstack/react-router';
import SearchPage from '@/pages/SearchPage.jsx';
import { useTweaks } from '@/hooks/useTweaks.js';

const TWEAK_DEFAULTS = {
  defaultView: 'grid',
  density: 'comfortable',
  showSavedSearches: true,
};

function ProfilesRoute() {
  const tweaks = useTweaks(TWEAK_DEFAULTS);
  return <SearchPage tweaks={tweaks} />;
}

export const Route = createFileRoute('/profiles')({ component: ProfilesRoute });
